@if (translate.get('ready') | async) {
  <app-navbar
    [projectCode]="projectCode"
    [projectStatus]="projectStatus"
    [lastUpdate]="lastUpdate"
    [projectId]="projectId"
    [currentProject]="currentProject"></app-navbar>
  <router-outlet></router-outlet>
  <app-toast-container></app-toast-container>
} @else {
  <ng-template #loadingTemplate> RootComponent works and translations are LOADING! </ng-template>
}
